"use client";
import React, { useEffect, useState } from "react";
import { Dropdown } from "new-react-bootstrap";

import {
  ResponsiveDrawerDropdown,
  DropdownToggle,
  DropdownItem,
} from "@stadium/ui/src/components/bootstrap-dropdown";

import SearchInput from "@sendmagic/prismic-nextjs/src/components/utils/SearchInput";

import defaultStyles from "./main.module.scss";

const noOptionDefaultValues = { text: "No Result", classes: "text-danger", optionValue: "" };

const SelectOption = ({
  id,
  text,
  optionValue,
  selectedValue,
  classes: className = "",
  styles = defaultStyles,
  responsive = false,
  name = "",
  onSelect = () => {},
  selectable = true,
  ...restProps
}) => {
  if(responsive) {
    const handleClick=()=>{
      if(!selectable) return;
      onSelect({ name, value: optionValue });
    }
    return(<DropdownItem
      key={optionValue}
      value={optionValue}
      isActive={optionValue === selectedValue}
      onClick={selectable ? handleClick : undefined}
      disabled={!selectable}
    >
      {text}
    </DropdownItem>)
  }
  return (
  <Dropdown.Item
    {...(Dropdown.Item.defaultProps || {})}
    className={`${className}`}
    eventKey={optionValue}
    active={!!selectedValue && selectedValue === optionValue}
    id={`${id}-${optionValue}`}
    bsPrefix={styles.dropdownItem}
    {...restProps}
  >
    {text}
  </Dropdown.Item>
  )
}

export const SelectDropdown = ({
  options,
  showSearchFilter,
  searchfilterOptions = {},
  noOption = noOptionDefaultValues,
  onSelect = () => {},
  name,
  styles = defaultStyles,
  responsive,
  ...restProps
}) => {
  const {
    label = null,
    placeholder = "",
    classes: className = "",
    id = `select-dropdown-${Date.now()}`,
    value: selectedValue = "",
    error = false,
    text = "",
    disabled = false,
    dropup = false,
  } = restProps;

  const [dropdownOptions, setDropdownOptions] = useState(options);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setDropdownOptions(options);
  }, [options]);

  const onFilter = (filteredOptions) => setDropdownOptions(filteredOptions);

  const renderSearchFilter = () => {
    if (showSearchFilter) {
      return (
        <SearchInput
          id={`${id}SearchFilter`}
          name={`${name}SearchFilter`}
          {...searchfilterOptions}
          data={options}
          onFilter={onFilter}
          reset={!isVisible}
          focus={isVisible}
          styles={styles !== defaultStyles ? styles : undefined}
        />
      );
    }
  };

  const renderOptions = () => {
    if (dropdownOptions.length) {
      return dropdownOptions.map(({ text: optionText, value: optionValue }) => (
        <SelectOption
          key={`${id}-${optionValue}`}
          id={id}
          text={optionText}
          optionValue={optionValue}
          selectedValue={selectedValue}
          styles={styles === defaultStyles ? undefined : styles}
          responsive={responsive}
          onSelect={onSelect}
          name={name}
        />
      ));
    }
    return <SelectOption {...noOption} styles={styles === defaultStyles ? undefined : styles} responsive={responsive} selectable={false}/>;
  };

  const onSelectOption = (value) => {
    onSelect({ name, value });
  };

  const onToggle = (isOpen) => {
    if (isOpen) {
      setIsVisible(isOpen);
    } else {
      setIsVisible(isOpen);
      setDropdownOptions(options);
    }
  };

  const dropdownClassNames = `${error ? styles.formInputError : ""}`;
  const dropdownToggleClassNames = `${styles.dropdownValue} ${
    selectedValue ? "" : styles.placeholderText
  }`;

  if(responsive) return (
    <div className={`${className} ${styles.dropdown} prismic-select-dropdown`}>
      <ResponsiveDrawerDropdown
        label={
          <DropdownToggle className={dropdownClassNames}>
            <span>{text || placeholder}</span>
          </DropdownToggle>
        }
        onToggle={onToggle}
        disabled={disabled}
      >
        {isVisible && (
          <>
            {renderSearchFilter()}
            {renderOptions()}
          </>
        )}
      </ResponsiveDrawerDropdown>
    </div>
  )

  return (
    <>
      {label && (
        <label htmlFor={label.for} className={label.classes}>
          {label.content}
        </label>
      )}
      <div className={`${className} ${styles.dropdown}`}>
        <Dropdown
          {...(Dropdown.defaultProps || {})}
          id={id}
          className={dropdownClassNames}
          onSelect={onSelectOption}
          onToggle={onToggle}
          disabled={disabled}
          dropup={dropup}
        >
          <Dropdown.Toggle
            {...(Dropdown.Toggle.defaultProps || {})}
            variant="block"
            bsPrefix={styles.dropdownToggle}
          >
            <div className={dropdownToggleClassNames}>{selectedValue ? text : placeholder}</div>
          </Dropdown.Toggle>
          <Dropdown.Menu {...(Dropdown.Menu.defaultProps || {})} bsPrefix={styles.dropdownMenu}>
            {renderSearchFilter()}
            {renderOptions()}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );
};
